
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ActionHandler } from '@app/core/components/actions/action.handler';
import { SalvarAssociacaoAction } from './master-salvar-associacao-associar-fundos.action';

@Injectable()
export class MasterAssociarFundosActions {
    constructor(
        private actionHandler: ActionHandler,
        
            private salvarAssociacaoAction: SalvarAssociacaoAction
            
        
    ) {}


    salvarAssociacao(context): Observable<any> {
        return this.actionHandler.perform(this.salvarAssociacaoAction, context);
    }


}